<template>
    <div v-loading="loadingInv">
        <div class="page-invoice scrollable">
            <div class="toolbar-mon" v-if="!showAlert">
                <el-row>
                    <el-col>
                        <el-tabs v-model="tabs" type="border-card">
                            <el-tab-pane label="Request Topup" name="topup">
                                <el-card>
                                    <el-form label-position="left" label-width="150px">
                                        <el-form-item label="Phone Number">
                                            <el-select
                                                v-model="reqTopUp.phone_number"
                                                size="medium"
                                                placeholder="Phone Number"
                                                @change="selectedPhone"
                                            >
                                                <el-option
                                                    v-for="numb in numberPhone"
                                                    :key="numb"
                                                    :label="numb"
                                                    :value="numb"
                                                >
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="Credit Type">
                                            <el-select v-model="reqTopUp.credit_type" size="medium" placeholder="Credit Type">
                                                <el-option
                                                    v-for="item in creditType"
                                                    :key="item.value"
                                                    :label="item.name"
                                                    :value="item.value"
                                                >
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="Remark">
                                            <el-input
                                                v-model="reqTopUp.remark"
                                                type="textarea"
                                                :rows="4"
                                                class="mt-10"
                                                placeholder="Remark"/>
                                        </el-form-item>
                                    </el-form>
                                </el-card>
                                <el-card class="mt-20">
                                    <template>
                                        <el-card
                                            v-for="(item, idx) in reqTopUp.master_request_topup_markets"
                                            :key="idx"
                                            class="mb-10"
                                        >
                                            <el-form :inline="true" label-position="top" class="demo-form-inline">
                                                <el-form-item label="Market Area">
                                                    <el-select
                                                        v-model="reqTopUp.master_request_topup_markets[idx].master_market_area_id"
                                                        style="width:150px;"
                                                        size="medium"
                                                        :default-first-option="true"
                                                        class="mb-10 mr-5"
                                                        placeholder="Market Area"
                                                        :disabled="!reqTopUp.phone_number"
                                                    >
                                                        <el-option
                                                            v-for="item in listMarketByNumber"
                                                            :key="item.master_market_area_id"
                                                            :label="item.master_market_area_name"
                                                            :value="item.master_market_area_id"
                                                            :disabled="isMarket(item.master_market_area_id) ? true : false"
                                                        >
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                                <el-form-item label="Authentication">
                                                    <el-input v-model="reqTopUp.master_request_topup_markets[idx].authentication" @keypress.native="numberOnly" type="text" style="width:150px;" size="medium" :disabled="!item.master_market_area_id"></el-input>
                                                </el-form-item>
                                                <el-form-item label="Marketing">
                                                    <el-input v-model="reqTopUp.master_request_topup_markets[idx].marketing" @keypress.native="numberOnly" type="text" style="width:150px;" size="medium" :disabled="!item.master_market_area_id"></el-input>
                                                </el-form-item>
                                                <el-form-item label="Utility">
                                                    <el-input v-model="reqTopUp.master_request_topup_markets[idx].utility" @keypress.native="numberOnly" type="text" style="width:150px;" size="medium" :disabled="!item.master_market_area_id"></el-input>
                                                </el-form-item>
                                                <el-form-item label="Service">
                                                    <el-input v-model="reqTopUp.master_request_topup_markets[idx].service" @keypress.native="numberOnly" type="text" style="width:150px;" size="medium" :disabled="!item.master_market_area_id"></el-input>
                                                </el-form-item>
                                                <el-form-item>
                                                    <el-button class="mt-30" v-if="reqTopUp.master_request_topup_markets.length > 1 && idx !== 0" type="danger" size="mini" @click="deleteMarketArea(idx)">
                                                        <i class="mdi mdi-delete-forever"></i> 
                                                    </el-button>
                                                </el-form-item>
                                            </el-form>
                                        </el-card>
                                    </template>
                                    <el-row
                                        class="mt-20"
                                        v-if="reqTopUp.master_request_topup_markets.length < marketLength"
                                    >
                                        <el-button @click="addListMarket" style="width: 100%;" type="primary">+ Add Market Area</el-button>
                                    </el-row>
                                </el-card>
                                <el-row class="mt-20">
                                    <el-button
                                        @click="addCreditQuota"
                                        :loading="loadingBtnAddCreditQuota"
                                        type="primary"
                                        :disabled="!reqTopUp.phone_number || !reqTopUp.credit_type || !reqTopUp.remark"
                                    >
                                        Save
                                    </el-button>
                                </el-row>
                            </el-tab-pane>
                            
                            <el-tab-pane label="General Ledger" name="generalLedger">
                                <el-row>
                                    <el-col>
                                        <el-date-picker
                                            style="width:320px;"
                                            v-model="selectedStartDate"
                                            range-separator="-"
                                            size="medium"
                                            type="daterange"
                                            placeholder="Pick a day"
                                            class="mr-10"
                                        >
                                        </el-date-picker>
                                        <el-select v-model="filterGeneralLedger.phone_number" clearable size="medium" class="mr-10" placeholder="Phone Number">
                                            <el-option
                                                v-for="numb in numberPhone"
                                                :key="numb"
                                                :label="numb"
                                                :value="numb"
                                            />
                                        </el-select>
                                        <el-select v-model="filterGeneralLedger.market" clearable size="medium" class="mr-10" placeholder="Market Area">
                                            <el-option
                                                v-for="(item, idx) in listMarkets"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id"
                                            />
                                        </el-select>
                                        <el-button
                                            type="primary"
                                            size="medium"
                                            style="width: 80px;"
                                            @click="searchGeneralLedger()"
                                            v-loading="loadingSearchLedger"
                                        >
                                            Search
                                        </el-button>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-table 
                                        height="500"
                                        v-loading="loadingTableLedger"
                                        element-loading-text="Loading..."
                                        element-loading-spinner="el-icon-loading" 
                                        class="mt-30"
                                        :data="listGeneralLedger"
                                    >
                                        <el-table-column property="information" label="Information" width="350">
                                            <template slot-scope="scope">
                                                <table>
                                                    <tr style="background-color: transparent;">
                                                        <td colspan="2">{{ `${scope.row.customer.customer_name} (${scope.row.phone_number})` }}</td>
                                                    </tr>
                                                    <tr style="background-color: transparent;">
                                                        <td style="width:130px;">Credit Type</td>
                                                        <td style="text-transform: capitalize">{{ `: ${scope.row.credit_type}` }}</td>
                                                    </tr>
                                                    <tr style="background-color: transparent;">
                                                        <td style="width:130px;">Reference</td>
                                                        <td>: System</td>
                                                    </tr>
                                                    <tr style="background-color: transparent;">
                                                        <td style="width:130px;">Created at</td>
                                                        <td>{{ `: ${formatedDate(scope.row.created_at)}` }}</td>
                                                    </tr>
                                                </table>
                                            </template>
                                        </el-table-column>
                                        <el-table-column property="market_area" label="Market Area" width="180">
                                            <template slot-scope="scope">
                                                <p v-if="scope.row.master_request_topup_markets.market_area">{{ scope.row.master_request_topup_markets.market_area.name }}</p>
                                                <p v-else>-</p>
                                            </template>
                                        </el-table-column>
                                        <el-table-column property="credit_type" label="Credit Type" width="150">
                                            <template slot-scope="scope">
                                                <table>
                                                    <tr style="background-color: transparent;">
                                                        <td>Authentication</td>
                                                    </tr>
                                                    <tr style="background-color: transparent;">
                                                        <td>Marketing</td>
                                                    </tr>
                                                    <tr style="background-color: transparent;">
                                                        <td>Utility</td>
                                                    </tr>
                                                    <tr style="background-color: transparent;">
                                                        <td>Service</td>
                                                    </tr>
                                                </table>
                                            </template>
                                        </el-table-column>
                                        <el-table-column property="credit_balance" label="Credit Balance" width="130">
                                            <template slot-scope="scope">
                                                <table>
                                                    <tr style="background-color: transparent;">
                                                        <td>{{ `${formatPrice(scope.row.master_request_topup_markets.authentication_before_topup)}` }}</td>
                                                    </tr>
                                                    <tr style="background-color: transparent;">
                                                        <td>{{ `${formatPrice(scope.row.master_request_topup_markets.marketing_before_topup)}` }}</td>
                                                    </tr>
                                                    <tr style="background-color: transparent;">
                                                        <td>{{ `${formatPrice(scope.row.master_request_topup_markets.utility_before_topup)}` }}</td>
                                                    </tr>
                                                    <tr style="background-color: transparent;">
                                                        <td>{{ `${formatPrice(scope.row.master_request_topup_markets.service_before_topup)}` }}</td>
                                                    </tr>
                                                </table>
                                            </template>
                                        </el-table-column>
                                        <el-table-column property="credit_request" label="Credit Request" width="130">
                                            <template slot-scope="scope">
                                                <table>
                                                    <tr style="background-color: transparent;">
                                                        <td>{{ `${formatPrice(scope.row.master_request_topup_markets.authentication)}` }}</td>
                                                    </tr>
                                                    <tr style="background-color: transparent;">
                                                        <td>{{ `${formatPrice(scope.row.master_request_topup_markets.marketing)}` }}</td>
                                                    </tr>
                                                    <tr style="background-color: transparent;">
                                                        <td>{{ `${formatPrice(scope.row.master_request_topup_markets.utility)}` }}</td>
                                                    </tr>
                                                    <tr style="background-color: transparent;">
                                                        <td>{{ `${formatPrice(scope.row.master_request_topup_markets.service)}` }}</td>
                                                    </tr>
                                                </table>
                                            </template>
                                        </el-table-column>
                                        <el-table-column property="mutation" label="Mutation" width="130">
                                            <template slot-scope="scope">
                                                <table>
                                                    <tr style="background-color: transparent;">
                                                        <td>{{ `${formatPrice(scope.row.master_request_topup_markets.authentication_after_topup)}` }}</td>
                                                    </tr>
                                                    <tr style="background-color: transparent;">
                                                        <td>{{ `${formatPrice(scope.row.master_request_topup_markets.marketing_after_topup)}` }}</td>
                                                    </tr>
                                                    <tr style="background-color: transparent;">
                                                        <td>{{ `${formatPrice(scope.row.master_request_topup_markets.utility_after_topup)}` }}</td>
                                                    </tr>
                                                    <tr style="background-color: transparent;">
                                                        <td>{{ `${formatPrice(scope.row.master_request_topup_markets.service_after_topup)}` }}</td>
                                                    </tr>
                                                </table>
                                            </template>
                                        </el-table-column>
                                        <el-table-column property="Remark" label="Remark" width="200">
                                            <template slot-scope="scope">
                                                <p>{{ scope.row.remark }}</p>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </el-row>
                            </el-tab-pane>
                        </el-tabs>
                    </el-col>
                </el-row>
            </div>
        </div>
        <el-alert title="Info" type="info" description="No Data" show-icon v-if="showAlert"></el-alert>
    </div>
</template>
<script>
import api from '@/networkClient'
import config from '@/config'
const moment = require('moment')
export default {
    name: 'CreditQuota',
    props: {
        tableData: {
            type: Array,
        },
        totalBilling:{
            type: Number
        },
        showAlert: {
            type: Boolean
        },
        loadingInvoice: {
            type: Boolean
        },
        number:{
            type: Array
        }
    },
    data(){
        return {
            fillNumb:'',
            numberCustomer: [],
            loadingDetail: false,
            detail: [],
            dialogFormVisible: false,
            detailNumber: '',
            formLabelWidth: '200px',
            loadingSync: false,
            selectedStartDate: [
                moment().format("YYYY-MM-DD"),
                moment().format("YYYY-MM-DD")
            ],
            totalTrx: 0,
            currentPage: 1,
            tabs:'topup',
            today: moment().format("dddd, DD MMM YYYY"),
            getToday: moment().format('DD MMM YYYY'),
            getMonth: moment().month()+1,
            selectedMonth: moment().format("YYYY-MM"),
            btnLoading: false,
            dataBilling: this.billing,
            loadingInv: false,
            dataTotalBilling:this.totalBilling,
            dataNumber: this.number,
            options: [], 
            table:[],
            trx: [],
            dataUsage:[],
            loading: {
                trx: false
            },
            creditType: [
                {
                    name: "Addition",
                    value: "addition"
                },
                {
                    name: "Reduction",
                    value: "reduction"
                }
            ],
            listMarkets: [],
            reqTopUp: {
                phone_number: "",
                customer_id: "",
                credit_type: "",
                remark: "",
                master_request_topup_markets: [
                    {
                        master_market_area_id: '',
                        authentication: 0,
                        marketing: 0,
                        utility: 0,
                        service: 0
                    }
                ]
            },
            loadingBtnAddCreditQuota: false,
            numberPhone: [],
            listGeneralLedger: [],
            filterGeneralLedger: {
                market: '',
                phone_number: ''
            },
            listDataMarket: [],
            loadingSearchLedger: false,
            loadingTableLedger: false,
            listMarketByNumber: [],
            marketLength: 0
        }
    },
    methods: {
        log(data) {
            console.log(data, " <<data");
        },
        selectedPhone() {
            this.listMarketByNumber = [];
            this.listDataMarket.map(item => {
                if (item.number === this.reqTopUp.phone_number) {
                    this.listMarketByNumber = item.markets
                }
            })
        },
        numberOnly(e) {
            var key = window.event ? e.keyCode : e.which;

            let isNumber = _.indexOf([8, 9, 27, 13, 190, 43], e.keyCode)
            if ( isNumber !== -1 ||
                // Allow: Ctrl+C, Command+C
                (e.keyCode === 86 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: Ctrl+A, Command+A
                (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: Ctrl+R, Command+R
                (e.keyCode === 82 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: home, end, left, right, down, up
                (e.keyCode > 42 && e.keyCode <= 49 && _.indexOf([44,45,46,47], e.keyCode) == -1)) {
                // let it happen, don't do anything
                return
            }
            // Ensure that it is a number and stop the keypress
            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode > 96 || e.keyCode < 200)) {
                e.preventDefault();
            }
        },
        formatedDate(date) {
            return moment(date).format('DD/MM/YYYY, hh:mm')
        },
        formatPrice(value) {
            // let val = (value/1).toFixed(2).replace('.', ',')
            if(typeof value == "string") value = parseFloat(value)

            if(value == null || value == "") return "-"
			return value.toLocaleString('id-ID', { minimumFractionDigits: Number.isInteger(value) ? 0 : 4 })
		},
        deleteMarketArea(idx) {
            this.reqTopUp.master_request_topup_markets.splice(idx, 1);
        },
        isMarket(country_code) {
            return _.find(this.reqTopUp.master_request_topup_markets, (v) => {
                return v.master_market_area_id === country_code
            })
        },
        addListMarket() {
            let tempData = {
                master_market_area_id: '',
                authentication: 0,
                marketing: 0,
                utility: 0,
                service: 0
            }
            
            this.reqTopUp.master_request_topup_markets.push(tempData);
        },
        searchGeneralLedger() {
            this.getGeneralLedger(this.filterGeneralLedger.phone_number, this.filterGeneralLedger.market);
        },
        async addCreditQuota() {
            this.reqTopUp.customer_id = this.$route.params.consumen;
            var data = this.reqTopUp;

            if (this.validate('topup')) {
                this.$message.error({
                    showClose: false,
                    message: 'Please fill all inputs!'
                });
            } else {
                this.loadingBtnAddCreditQuota=true;
                await api({
                    method: "post",
                    data: data,
                    url: config.baseApi + "master-request-topup"
                }).then(resp => {
                    const status =
                        resp &&
                        resp.data &&
                        resp.data.ec
                            ? resp.data.ec
                            : null;
                    const message =
                        resp &&
                        resp.data &&
                        resp.data.message
                            ? resp.data.message
                            : null;
    
                    if(status == 200){
                        this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
                    } else if (message === 'not_allowed') {
                        this.$swal(this.$t('error'), 'User not allowed to request topup!', "error").then(this.clear())
                    } else {
                        this.$swal(this.$t('warning'), message, "warning").then(this.clear())
                    }
                }).catch(err => {
                    console.log("failed", err)
                })
                this.loadingBtnAddCreditQuota=false;
            }
        },
        async getListMarket(){
			await api({
				method: "get",
				url: config.baseApi + "master-market-area"
			}).then(resp => {
                const status =
                    resp &&
                    resp.data &&
                    resp.data.ec
                        ? resp.data.ec
                        : null;
                const data =
                    resp &&
                    resp.data &&
                    resp.data.data &&
                    resp.data.data.rows
                        ? resp.data.data.rows
                        : [];
				if(status == 200){
                    this.listMarkets = data;
				}
			}).catch(err => {
				console.log("failed", err)
			})
		},
        async loadWA() {
			let custId = this.$route.params.consumen;
			await api({
				method: 'post',
				url: config.baseApi +'user/'+custId+'/detail_number'
			}).then(result => {
                var data =
                    result &&
                    result.data &&
                    result.data.data
                        ? result.data.data
                        : [];
                this.numberPhone = data
			}).catch(error => {
				console.log(error);
			})
    	},
        async getGeneralLedger(phone_number, market){
            let custId = this.$route.params.consumen;
            this.loadingSearchLedger = true;
            this.loadingTableLedger = true;
            var params = {
                customer_id: custId,
                phone_number: phone_number,
                market: market
            }
            await api({
				method: 'get',
				url: config.baseApi +'master-request-topup',
                params: params
			}).then(result => {
                var data =
                    result &&
                    result.data &&
                    result.data.data &&
                    result.data.data.rows
                        ? result.data.data.rows
                        : [];

                var status =
                    result &&
                    result.data &&
                    result.data.ec
                        ? result.data.ec
                        : null;

                if(status === 200) {
                    var tempData = [];
                    data.map(item => {
                        item.master_request_topup_markets.map(item2 => {
                            let tempItem = {
                                id: item.id,
                                phone_number: item.phone_number,
                                customer_id: item.customer_id,
                                customer: item.customer,
                                credit_type: item.credit_type,
                                remark: item.remark,
                                status: item.status,
                                approved_at: item.approved_at,
                                rejected_at: item.rejected_at,
                                canceled_at: item.canceled_at,
                                approved_by: item.approved_by,
                                rejected_by: item.rejected_by,
                                canceled_by: item.canceled_by,
                                created_at: item.created_at,
                                updated_at: item.updated_at,
                                created_by: item.created_by,
                                updated_by: item.updated_by,
                                master_request_topup_markets: {}
                            }

                            if(item2.master_request_topup_id === item.id && tempItem.master_request_topup_markets) {
                                let request_topup_markets = {
                                    id: item2.id,
                                    master_request_topup_id: item2.master_request_topup_id,
                                    master_market_area_id: item2.master_market_area_id,
                                    marketing: item2.marketing,
                                    authentication: item2.authentication,
                                    utility: item2.utility,
                                    service: item2.service,
                                    marketing_after_topup: item2.marketing_after_topup,
                                    marketing_before_topup: item2.marketing_before_topup,
                                    authentication_after_topup: item2.authentication_after_topup,
                                    authentication_before_topup: item2.authentication_before_topup,
                                    utility_after_topup: item2.utility_after_topup,
                                    utility_before_topup: item2.utility_before_topup,
                                    service_after_topup: item2.service_after_topup,
                                    service_before_topup: item2.service_before_topup
                                }

                                if(item2.market_area) {
                                    request_topup_markets.market_area = {
                                        id: item2.market_area.id,
                                        code: item2.market_area.code,
                                        name: item2.market_area.name,
                                        status: item2.market_area.status,
                                        created_at: item2.market_area.created_at,
                                        updated_at: item2.market_area.updated_at,
                                        created_by: item2.market_area.created_by,
                                        updated_by: item2.market_area.updated_by
                                    }
                                }

                                tempItem.master_request_topup_markets = request_topup_markets;
                            }

                            tempData.push(tempItem);
                        })
                    })
                    this.listGeneralLedger = tempData;
                }

                this.loadingSearchLedger = false;
                this.loadingTableLedger = false;
			}).catch(error => {
				console.log(error);
			})
		},
        async listMarketArea(){
            let custId = this.$route.params.consumen
            await api({
                url: config.baseApi + 'master-consumen/' + custId + "/product-market-area",
                method: 'get'
            })
            .then(res => {
                var data =
                    res &&
                    res.data &&
                    res.data.data
                        ? res.data.data
                        : '';

                this.listDataMarket = data;
                this.marketLength = data && data[0] && data[0].markets ? data[0].markets.length : 0;
            })
            .catch(err => {
                this.$swal(this.$t('error'), this.$t('error_text'), "error").then(this.clear())
                return err
            })
        },
        clear() {
            var clearData = {
                phone_number: "",
                customer_id: "",
                credit_type: "",
                remark: "",
                master_request_topup_markets: [
                    {
                        master_market_area_id: '',
                        authentication: 0,
                        marketing: 0,
                        utility: 0,
                        service: 0
                    }
                ]
            }

            this.reqTopUp = clearData;
        },
        validate(type) {
            let result = false;
            if (type === 'topup') {
                let data =
                    this.reqTopUp &&
                    this.reqTopUp.master_request_topup_markets
                        ? this.reqTopUp.master_request_topup_markets
                        : [];

                data.map(item => {
                    if (
                        item.authentication === '' ||
                        item.marketing === '' ||
                        item.utility === '' ||
                        item.service === ''
                    ) {
                        result = true;
                    }
                });
            }
            return result;
        }
    },
    async mounted(){
        await this.getGeneralLedger();
        await this.getListMarket();
        await this.loadWA();
        await this.listMarketArea();
    },
    watch:{
    }
}
</script>
<style lang="scss">
.toolbar-mon {
    max-width: 100%;
    margin: 0 auto;
    margin-bottom: 20px;
}
.header-text{
	font-weight: 700;
	color: #000;
	opacity: 0.7;
}

.wa-number{
    font-size: 1em;
}

.el-table {
    .cell-custom {
        padding: 15px 0;
    }

    thead.is-group{
        th {
            text-align: center;
        }    
    } 
        
    // th > .cell {
    //     text-align: center;
    // }
}

.el-table--group::after, .el-table--border::after {
    width: 0%;
}

</style>

